module.exports = __webpack_public_path__ + "static/blp-7612f4cb8bc448cee5136cf15e191f90.png";